import { useEffect, type RefObject } from "react";

/**
 * Leva o cartão de detalhe à vista quando a seleção muda (Usuários e
 * Núcleos). Lado a lado, o cartão fica fixo no topo (`position: sticky`,
 * com rolagem própria) e já está visível: aqui só volta a rolagem interna
 * pro começo, senão a pessoa nova abria no meio, onde a anterior estava.
 * Empilhado (tela estreita), o cartão fica DEPOIS da lista, e quem
 * escolheu alguém no fim da lista não via o que abriu — aí a página rola
 * até ele.
 *
 * Depende só do id: as recargas depois de uma escrita trazem um objeto
 * novo da mesma pessoa, e isso não pode puxar a página de volta.
 */
export function useRevealDetail(ref: RefObject<HTMLElement | null>, selectedId: number | undefined) {
  useEffect(() => {
    const card = ref.current;
    if (!card || selectedId === undefined) return;
    card.scrollTop = 0;
    const { top } = card.getBoundingClientRect();
    const outOfView = top < 0 || top > window.innerHeight * 0.6;
    // O jsdom não tem `scrollIntoView`.
    if (!outOfView || typeof card.scrollIntoView !== "function") return;
    const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    card.scrollIntoView({ block: "start", behavior: reduced ? "auto" : "smooth" });
  }, [ref, selectedId]);
}
